<script>
   /***************************************************************
    * ButtonCancel                                                *
    * --------------------                                        *
    * control element in form of red circle button with cross     *
    ***************************************************************/
   export let title = 'Reset';
</script>

<button tabindex="0" on:click alt={title} title={title} ></button>

<style>

   button {
      background: #606060;
      display: inline-block;
      color: #fefefe;
      font-size: 1em;
      width: 1.3em;
      height: 1.3em;
      border: none;
      border-radius: 50%;
      box-shadow: none;
      margin-left: 1.5em;
      text-align: center;
      padding: 0;
      background-size: 40% 40%;
      background-position: 50%;
      background-repeat: no-repeat;
      background-image:
        url('data:image/svg+xml;utf8,<svg viewBox="0 0 100 100" version="1.1" style="stroke:%23fafafa;stroke-width:14;" xmlns="http://www.w3.org/2000/svg"><line x1="0" y1="0" x2="100" y2="100"/><line x1="0" y1="100" x2="100" y2="0"/></svg>');
   }

   button:hover {
      background-color: crimson;
   }

</style>
